import { render } from "./ListaAnalises.vue?vue&type=template&id=510e6c74"
import script from "./ListaAnalises.vue?vue&type=script&lang=js"
export * from "./ListaAnalises.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__